<script>
export default {
  name: "PhaseSalesColor",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const fase = context.props.row.phaseDescription;
    // este se usa para kpi de Prospeccion

    if (fase == "Ganada") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        "Ganada"
      );
    } else if (fase == "Perdida") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "Perdida"
      );
    } else {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--plain"
        },
        "En proceso"
      );
    }
  }
};
</script>
